import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled';

import type { AutomationRuleSummary_experimentalAutomationRuleSummary_componentSummaries as ComponentSummary } from '../../__types__/AutomationRuleSummaryQuery.ts';

import { ComponentPreview } from './ComponentPreview.tsx';

type RuleActionsPreviewProps = {
	actionSummaries: ComponentSummary[];
};

export const RuleActionsPreview = ({ actionSummaries }: RuleActionsPreviewProps) => {
	return (
		<Stack space="space.150">
			{actionSummaries.map((summary) => (
				<ComponentPreview
					key={summary.type}
					componentType={summary.type}
					componentName={summary.componentName}
				/>
			))}
		</Stack>
	);
};
